// List block active state

jQuery(".list-block .list-item").hover(function () {

    // Remove selectedRow class from any rows having it in this table
    jQuery('.active', jQuery(this).parent()).removeClass("active");

    // Add it to the clicked row
    jQuery(this).addClass("active");

});

//flickity settings

jQuery(function() {

    // HOME CAROUSEL
    var testimonialsCarousel = jQuery('.testimonials-carousel');

    if (testimonialsCarousel.length) { // here you validate if there is any element with that class
        jQuery('.testimonials-carousel').flickity({
            // options
            cellSelector: '.carousel-cell',
            adaptiveHeight: true,
            pageDots: true,
            prevNextButtons: false,
            imagesLoaded: true,
            wrapAround: false,
            autoPlay: 9000
        });
    }
});

jQuery(window).on('load', function() {

    // Hero / Banner

    window.sr = ScrollReveal().reveal('.reveal-image', { 
        duration: 1500,
        distance: '0',
        origin: 'bottom',
        easing: 'linear',
        delay:0,
        scale: 1.03
    });

    // Generic Step Down

    window.sr = ScrollReveal().reveal('.reveal-step-down', { 
        interval: 120,
        duration: 1200,
        distance: '2rem',
        origin: 'top',
        easing: 'cubic-bezier(.2,1,.22,1)',
        delay:100,
        scale: 1
    });

    // Generic Step Up

    window.sr = ScrollReveal().reveal('.reveal-step-up', { 
        interval: 200,
        duration: 1500,
        distance: '2rem',
        origin: 'bottom',
        easing: 'cubic-bezier(.2,1,.22,1)',
        delay:100,
        scale: 1
    });

    // Image Block


    window.sr = ScrollReveal().reveal('.shape', { 
        duration: 1500,
        distance: '4rem',
        origin: 'bottom',
        easing: 'cubic-bezier(.2,1,.22,1)',
        delay:100,
        scale: 1
    });

    // List Items

    window.sr = ScrollReveal().reveal('.list-item', { 
        interval: 180,
        duration: 2800,
        distance: '3rem',
        origin: 'bottom',
        easing: 'cubic-bezier(.2,1,.22,1)',
        delay:50,
        scale: 1
    });

    window.sr = ScrollReveal().reveal('.accordion-item', { 
        interval: 180,
        duration: 2800,
        distance: '3rem',
        origin: 'bottom',
        easing: 'cubic-bezier(.2,1,.22,1)',
        delay:50,
        scale: 1
    });


    // General

    window.sr = ScrollReveal().reveal('.reveal-text', { 
        interval: 200,
        duration: 1600,
        distance: '2rem',
        origin: 'bottom',
        easing: 'cubic-bezier(.2,1,.22,1)',
        delay:100,
        scale: 1
    });
});